import React from 'react';
import styled from 'styled-components';
import Button from './atoms/Buttons';
import ChampionshipCup from './tournament/ChampionshipCup';

const Area = styled.section`
  display: flex;
  flex: 1;
  min-height: 0;
  padding: clamp(20px, 4vh, 48px) 24px;
  overflow-y: auto;
  box-sizing: border-box;
  font-family: 'Open Sans', sans-serif;
  & *, & *::before, & *::after { box-sizing: border-box; }
  @media (max-width: 600px) { padding: 24px 14px; }
`;

const Content = styled.div`
  width: min(100%, 1000px);
  margin: auto;
  padding: clamp(28px, 4vh, 52px) clamp(20px, 4vw, 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  text-align: center;
  @media (max-height: 700px) { gap: 16px; padding-block: 24px; }
`;

const Heading = styled.h1`
  margin: 0;
  max-width: 780px;
  color: #ffe69a;
  font-size: clamp(26px, 3vw, 52px);
  font-weight: 800;
  line-height: 1.13;
  letter-spacing: .02em;
  text-transform: uppercase;
  text-wrap: balance;
  text-shadow: 0 2px 0 #6c340b;
`;

const Message = styled.p`
  margin: 0;
  color: #fff1d6;
  font-size: clamp(16px, 1.5vw, 24px);
  font-weight: 600;
  line-height: 1.5;
  text-wrap: balance;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  margin-top: 14px;
  & > button { min-width: 190px; }
  & > button:last-child { min-width: min(100%, 280px); }
  @media (max-width: 600px) {
    gap: 14px;
    margin-top: 6px;
    & > button { width: 100%; min-width: 0; }
  }
`;

export default function TournamentClassificationClosed({ onHome, onShowWinner }) {
  return (
    <Area aria-labelledby="classification-closed-title" className="custom-scroll">
      <Content>
        <ChampionshipCup />
        <Heading id="classification-closed-title">La clasificación ha concluido</Heading>
        <Message>El ganador se mostrará en breve</Message>
        <Actions>
          <Button variant="outline" onClick={onHome}>INICIO</Button>
          <Button onClick={onShowWinner}>MOSTRAR GANADOR</Button>
        </Actions>
      </Content>
    </Area>
  );
}
